/* Live-Mockup fuer Wende-Bettwaesche: reagiert auf das Event "wende:change" */
(function () {
  "use strict";

  var root = document.querySelector("[data-wende-mockup]");
  if (!root) {
    return;
  }

  var scene = root.getAttribute("data-wende-mockup-scene");
  var whiteBett = root.getAttribute("data-white-bett");

  function getConfig() {
    var el = document.querySelector("[data-pdp-wende-config]");
    if (!el) {
      return null;
    }
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  var config = getConfig();
  var stoffe = (config && config.stoffe) || [];

  function findFabric(handle) {
    for (var i = 0; i < stoffe.length; i++) {
      if (stoffe[i].handle === handle) {
        return stoffe[i];
      }
    }
    return null;
  }

  function parseKey(key) {
    if (!key) {
      return null;
    }
    var parts = String(key).split("|");
    return { handle: parts[0], flip: parts[1] || null };
  }

  function mockField(fabric, flip, lightField, darkField) {
    if (!fabric) {
      return null;
    }
    var field = flip === "dunkel" ? darkField : lightField;
    return fabric[field] || null;
  }

  function swatch(fabric, flip) {
    if (!fabric) {
      return null;
    }
    if (flip === "dunkel") {
      return fabric.imgDark || fabric.img || null;
    }
    return fabric.img || null;
  }

  function setBg(el, url, startOpacity) {
    if (!el) {
      return;
    }
    if (!url) {
      el.style.backgroundImage = "";
      el.style.opacity = 1;
      return;
    }
    var img = new Image();
    el.style.opacity = startOpacity || 0.4;
    img.onload = function () {
      el.style.backgroundImage = "url('" + url + "')";
      el.style.opacity = 1;
    };
    img.src = url;
  }

  function setPillowSide(side, fabric, flip) {
    var layer = root.querySelector('[data-wende-layer="' + side + '"]');
    var imgEl = root.querySelector('[data-wende-img="' + side + '"]');
    var fillEl = root.querySelector('[data-wende-fill="' + side + '"]');
    if (!layer) {
      return;
    }
    var mock = mockField(fabric, flip, "mockK", "mockKD");
    if (mock) {
      layer.classList.add("use-img");
      setBg(imgEl, mock, 0.4);
    } else {
      layer.classList.remove("use-img");
      if (fabric) {
        setBg(fillEl, swatch(fabric, flip), 0.35);
      } else if (fillEl) {
        fillEl.style.backgroundImage = "";
        fillEl.style.opacity = 1;
      }
    }
  }

  function setBedSide(side, fabric, flip) {
    var layer = root.querySelector('[data-wende-layer="' + side + '"]');
    var imgEl = root.querySelector('[data-wende-img="' + side + '"]');
    var fillEl = root.querySelector('[data-wende-fill="' + side + '"]');
    if (!layer) {
      return;
    }
    var mock = mockField(fabric, flip, "mockB", "mockBD");
    if (side === "B") {
      if (!fabric) {
        layer.hidden = true;
        return;
      }
      layer.hidden = false;
      if (mock) {
        layer.classList.add("use-img");
        setBg(imgEl, mock, 0.4);
      } else {
        layer.classList.remove("use-img");
        setBg(fillEl, swatch(fabric, flip), 0.35);
      }
    } else {
      if (!fabric) {
        layer.hidden = true;
        return;
      }
      layer.hidden = false;
      if (mock) {
        layer.classList.add("use-img");
        setBg(imgEl, mock, 0.4);
      } else {
        layer.classList.remove("use-img");
        setBg(fillEl, swatch(fabric, flip), 0.35);
      }
    }
  }

  function update(detail) {
    if (!detail) {
      return;
    }
    var a = parseKey(detail.keyA);
    var b = parseKey(detail.keyB);
    var fabricA = a ? findFabric(a.handle) : null;
    var fabricB = b ? findFabric(b.handle) : null;
    var flipA = a ? a.flip : null;
    var flipB = b ? b.flip : null;

    if (scene === "pillow") {
      setPillowSide("A", fabricA, flipA);
      setPillowSide("B", fabricB, flipB);
    } else {
      setBedSide("B", fabricB, flipB);
      setBedSide("A", fabricA, flipA);
    }

    var badgeA = root.querySelector('[data-wende-badge="A"]');
    var badgeB = root.querySelector('[data-wende-badge="B"]');
    if (badgeA) {
      badgeA.textContent = fabricA ? (fabricA.farbe || fabricA.name) : "Seite A wählen";
    }
    if (badgeB) {
      badgeB.textContent = fabricB ? (fabricB.farbe || fabricB.name) : "Seite B wählen";
    }

    var hint = root.querySelector("[data-wende-empty-hint]");
    if (hint) {
      hint.style.display = (fabricA || fabricB) ? "none" : "grid";
    }
  }

  if (scene !== "pillow") {
    setBg(root.querySelector("[data-wende-base]"), whiteBett, 1);
  }

  document.addEventListener("wende:change", function (e) {
    update(e.detail || {});
  });

  if (window.__wendeState) {
    update(window.__wendeState);
  }
})();
